import { render, staticRenderFns } from "./BtnSeleccion.vue?vue&type=template&id=78c55eb6&"
import script from "./BtnSeleccion.vue?vue&type=script&lang=js&"
export * from "./BtnSeleccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports